module.exports = new __parcel__URL__("something-wrong.1260804e.svg").toString();